var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.layout === 'pira')?_c('nav-pira'):_vm._e(),(_vm.layout === 'gru')?_c('nav-gru'):_vm._e(),(_vm.layout === 'mogi')?_c('nav-mogi'):_vm._e(),(_vm.layout === 'serget')?_c('nav-serget'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }